import { InboxIcon } from './icons';

/**
 * Icon + friendly copy + optional CTA — the design system's replacement
 * for a bare "no data" paragraph. `icon` defaults to a generic inbox glyph;
 * pass a more specific one (e.g. FileTextIcon, MessageCircleIcon) where it
 * adds clarity.
 */
export default function EmptyState({ icon: Icon = InboxIcon, title, body, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-6">
      <div className="h-12 w-12 rounded-2xl bg-accent-soft text-accent flex items-center justify-center mb-4">
        <Icon className="h-6 w-6" />
      </div>
      <p className="text-sm font-medium text-foreground mb-1">{title}</p>
      {body && <p className="text-sm text-foreground-muted max-w-sm">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
